import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage, injectIntl } from 'react-intl'
import { Form, Field } from 'react-final-form'
import { Box, Text } from '@chakra-ui/react'
import { Input } from 'src/components/Form'
import Button from 'src/components/Button/Button'
import { Footer, Layout, Container, Content, PageTitle } from 'src/components/Layout'
import intlMessages from '../translations'

class AddPassenger extends Component {
  static contextTypes = {
    router: PropTypes.object,
  }

  handleSubmit = values => {
    this.props.setPassenger(values)
    this.props.history.push('/claims/form')
  }

  handleBack = () => {
    this.props.history.push('/claims/passenger')
  }

  validateFormFields = values => {
    const { intl } = this.props

    const errors = {}
    if (!values.firstName) {
      errors.firstName = intl.formatMessage(intlMessages.validationFirstNameRequired)
    }

    if (!values.lastName) {
      errors.lastName = intl.formatMessage(intlMessages.validationLastNameRequired)
    }

    return errors
  }

  render() {
    const { passenger, intl } = this.props

    return (
      <Layout className='m-claims-passenger-add-passenger'>
        <Content>
          <PageTitle
            showBack={true}
            title={intl.formatMessage(intlMessages.passengerHeadline)}
            subtitle={'Fill out the form'}
          />
          <Container padder className='global-centered-desktop-content'>
            <Form
              onSubmit={this.handleSubmit}
              validate={this.validateFormFields}
              render={({ handleSubmit }) => (
                <form onSubmit={handleSubmit}>
                  <Content>
                    <Text
                      fontWeight={500}
                      variant='secondary'
                      mt={'20px'}
                      fontSize={'16px'}
                      align={'center'}
                    >
                      <FormattedMessage
                        id='app.passenger.headline'
                        defaultMessage='Passenger Info'
                      />
                    </Text>
                    <Field
                      name='firstName'
                      initialValue={passenger && passenger.firstName}
                      render={({ input, meta }) => (
                        <Box mt={'15px'} mb={'10px'}>
                          <Input
                            name='firstName'
                            error={meta}
                            placeholder={intl.formatMessage(intlMessages.placeholderFirstName)}
                            type='text'
                            {...input}
                          />
                        </Box>
                      )}
                    />
                    <Field
                      name='lastName'
                      initialValue={passenger && passenger.lastName}
                      render={({ input, meta }) => (
                        <Box mt={'15px'} mb={'10px'}>
                          <Input
                            name='lastName'
                            error={meta}
                            placeholder={intl.formatMessage(intlMessages.placeholderLastName)}
                            type='text'
                            {...input}
                          />
                        </Box>
                      )}
                    />

                    <Field
                      name='phone'
                      initialValue={passenger && passenger.phone}
                      render={({ input }) => (
                        <Box mt={'15px'} mb={'10px'}>
                          <Input
                            name='phone'
                            placeholder={intl.formatMessage(intlMessages.placeholderPhoneNumber)}
                            type='text'
                            {...input}
                          />
                        </Box>
                      )}
                    />

                    <Field
                      name='address'
                      initialValue={passenger && passenger.address}
                      render={({ input }) => (
                        <Box mt={'15px'} mb={'10px'}>
                          <Input
                            name='address'
                            placeholder={intl.formatMessage(intlMessages.placeholderAdress)}
                            type='text'
                            {...input}
                          />
                        </Box>
                      )}
                    />
                  </Content>

                  <Footer>
                    <Button mt={'30px'} isFullWidth type='submit'>
                      <FormattedMessage id='app.passenger.submit' defaultMessage='Submit' />
                    </Button>
                  </Footer>
                </form>
              )}
            />
          </Container>
        </Content>
      </Layout>
    )
  }
}

export default injectIntl(AddPassenger)
